import { render, staticRenderFns } from "./examImportQuestion.vue?vue&type=template&id=908aa968&scoped=true&"
import script from "./examImportQuestion.vue?vue&type=script&lang=js&"
export * from "./examImportQuestion.vue?vue&type=script&lang=js&"
import style0 from "./examImportQuestion.vue?vue&type=style&index=0&id=908aa968&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "908aa968",
  null
  
)

export default component.exports